"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("../../modules/database/store/interfaces/resource"), exports);
__exportStar(require("../../modules/space/store/interfaces/catalog_tree"), exports);
__exportStar(require("../../modules/user/store/interfaces/user"), exports);
__exportStar(require("../../modules/org/store/interface/address_list"), exports);
__exportStar(require("../../modules/org/store/interface/space_member_manage"), exports);
__exportStar(require("../../modules/space/store/interfaces/space"), exports);
__exportStar(require("../../modules/org/store/interface/invite"), exports);
__exportStar(require("../../modules/org/store/interface/space_permission_manage"), exports);
__exportStar(require("../../modules/user/store/interfaces/notification"), exports);
__exportStar(require("../../modules/space/store/interfaces/template_centre"), exports);
__exportStar(require("../../modules/enterprise"), exports);
__exportStar(require("../../modules/org/store/interface/tool_bar"), exports);
__exportStar(require("../../modules/database/store/interfaces/kanban"), exports);
__exportStar(require("../../modules/database/store/interfaces/common"), exports);
__exportStar(require("../../modules/database/store/interfaces/resource"), exports);
__exportStar(require("../../modules/database/store/interfaces/apphook"), exports);
__exportStar(require("../../modules/space/store/interfaces/share"), exports);
__exportStar(require("../../modules/org/store/interface/unit_info"), exports);
__exportStar(require("../../modules/database/store/interfaces/params"), exports);
__exportStar(require("../../modules/space/store/interfaces/labs"), exports);
__exportStar(require("../../modules/database/store/interfaces/subscriptions"), exports);
__exportStar(require("../../modules/database/store/interfaces/record_vision_mode"), exports);
__exportStar(require("../../modules/database/store/interfaces/preview_file"), exports);
__exportStar(require("../../modules/embed/store/interfaces/embed"), exports);
//# sourceMappingURL=interfaces.js.map